<template>
    <div style="background-color: #f5f5f5;">
        <div class="banner1">
            <img src="../assets/img/banner4.jpg" alt="banner" />
        </div>

        <div class="block">
            <div class="center">
                <div class="left_bar">
                    <div class="title">人才招聘</div>
                    <ul>
                        <li><a href="javascript:void(0);" @click.stop="goTo('JobList?zplb=702')">社会招聘</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('JobList?zplb=701')">校园招聘</a></li>
                    </ul>
                </div>
                <div class="right_contnet">
                    <div class="job_show">
                        <div class="date_time">发布时间：{{ job.createDate }}</div>
                        <div class="title"><i v-show="job.node04 == 'y'">急</i>{{ job.zhiwei }}</div>
                        <div class="yuexin">{{ job.yuexin }}</div>
                        <div class="bumen">部门：{{ job.node03 }}</div>
                        <div class="diqu">工作地点：{{ job.diqu }}</div>

                        <div class="title1"><span>岗位描述</span></div>
                        <div class="p" v-html="job.gwjs"></div>

                        <div class="title1"><span>岗位职责</span></div>
                        <div class="p" v-html="job.node01"></div>

                        <div class="title1"><span>任职要求</span></div>
                        <div class="p" v-html="job.zyyq"></div>

                        <div v-if="job.node04 =='Y'">
                            <a href="javascript:void(0);" class="apply" @click.stop="jump_zhaopin( job.node02 )">申请职位</a>
                            <a href="javascript:void(0);" class="apply1" @click.stop="jump_zhaopin( job.node02 )">申请职位</a>
                        </div>
                        <div v-else>
                            <a href="javascript:void(0);" class="apply apply_disable" title="该职位已过期">职位已过期</a>
                            <a href="javascript:void(0);" class="apply1 apply_disable" title="该职位已过期">职位已过期</a>
                            <a href="javascript:void(0);" class="apply" @click="goTo('/Contact');">联系我们</a>
                        </div>

                        <!-- <div v-if="job.node02 != '' && job.node04 !='N'">
                            <a href="javascript:void(0);" class="apply" @click.stop="jump_zhaopin( job.node02 )">申请职位</a>
                            <a href="javascript:void(0);" class="apply1" @click.stop="jump_zhaopin( job.node02 )">申请职位</a>
                        </div>
                        <div v-else>
                            <a href="javascript:void(0);" class="apply" @click="goTo('/Map');">联系我们</a>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import { RenCaiZhaoPin } from "../request/api"; // 导入接口

export default {
    name: 'Home',
    data() {
        return {
            title: '最新职位',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            article_list: '',
            n_job_list:'',
            job:{
                createDate: '' , //创建时间
                node04: '' , //是否急聘n-否 y-是
                zhiwei: '' , //招聘职位
                yuexin: '', //月薪
                node03: '' , //工作部门
                diqu: '' ,  //工作地区
                gwjs: '' ,  //岗位描述
                node01: '' ,  //岗位职责
                zyyq: '' ,  //任职要求
                node02: '' , //智联连接
                node04: '', //是否有效
            },

            id: this.$route.query.id, //传入的id
            zplb: this.$route.query.zplb, //传入的id

            //翻页
            pageNum: 1, //当前页
            pageSize: 1, //每页显示数
            total : 0, //总数据

            total_page : '', //总页数
            page_pre : 0, //上一页
            page_next : 0, //下一页
            
        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        this.RenCaiZhaoPin_data ( this.id,this.zplb );
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
    },
    methods: {
        goTo(e) {
            this.$router.push(e);
        },
        jump_zhaopin( e ){
            window.open( e ,'_blank');
            //open.window = "http://jobs.zhaopin.com/CC194135910J40340826307.htm?refcode=4019&srccode=401901&preactionid=5dc3c5b7-0d7b-4120-842c-20a94116b821";
        },
        RenCaiZhaoPin_data( id, zplb ){ //文章分类显示
            RenCaiZhaoPin({
                id: id,
                zplb: zplb, //分类
            }).then((res) => {
                console.log( res );

                this.job.createDate = res.rows[0].createDate; //创建时间
                this.job.node04 = res.rows[0].node04; //是否急聘n-否 y-是

                this.job.yuexin = res.rows[0].yuexin; //月薪
                
                this.job.zhiwei = res.rows[0].zhiwei; //招聘职位
                this.job.node03 = res.rows[0].node03; //工作部门
                this.job.diqu = res.rows[0].diqu;  //工作地区
                this.job.gwjs = res.rows[0].gwjs;  //岗位描述
                this.job.node01 = res.rows[0].node01;  //岗位职责
                this.job.zyyq = res.rows[0].zyyq;  //任职要求
                this.job.node02 = res.rows[0].node02; //智联连接
                this.job.node04 = res.rows[0].node04; //是否有效
                
                
            });
        },
    },
};
</script>
<style lang="less" scoped>
#job_list ul{
    margin:0px 30px;
}
#job_list li{
    margin: 10px auto;
    padding: 20px 30px;
    height: 110px;
    border: 1px solid #ddd;
    background-color: #fff;
}
#job_list li:hover{
    background-color: #f5f5f5;
}

#job_list li .t{
    display:block;
    height:40px;
    line-height:40px;
    font-size:20px;
    margin-bottom:20px;
    background-repeat: no-repeat;
    background-size: 60px auto;
    background-position: center right;
	background-image: url('data:image/png;base64,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');
}
#job_list li .t i{
    display: inline-block;
    width:20px;
    height:20px;
    line-height:20px;
    font-size:14px;
    color:#fff;
    background-color: #d6000f;
    font-style: normal;
    text-align: center;
    font-size:14px;
    vertical-align: top;
    margin:10px 5px 0px 0px;
}
.job_show{
    margin:20px 30px;
    position: relative;
}
.job_show .date_time{
    font-size:14px;
    height:30px;
    line-height:30px;
    color:#999;
}
.job_show .title{
    font-size:30px;
    color:#333;
    height:40px;
    line-height: 40px;
    padding:10px 0px;
}
.job_show .title i{
    display: inline-block;
    width:20px;
    height:20px;
    line-height:20px;
    font-size:14px;
    color:#fff;
    background-color: #d6000f;
    font-style: normal;
    text-align: center;
    font-size:14px;
    vertical-align: top;
    margin:10px 5px 0px 0px;
}
.job_show .yuexin{
    height: 30px;
    line-height: 30px;
    font-size: 25px;
    color:#D6000F;
    margin: 10px 0px;
}
.job_show .bumen{
    font-size:14px;
    height:30px;
    line-height:30px;
    color:#999;
}
.job_show .diqu{
    font-size:14px;
    height:30px;
    line-height:30px;
    color:#999;
}
.job_show .title1{
    position: relative;
    font-size:20px;
    height:40px;
    line-height: 40px;
}
.job_show .title1 span{
    position: absolute;
    z-index:10;
    display: inline-block;
    padding: 0px 20px 0px 0px;
    height:40px;
    line-height: 40px;
    background-color: #fff;
}

.job_show .title1:after{
    position: absolute;
    content: '';
    left: 0px;
    top: 20px;
    width:100%;
    height:1px;
    border-top: 1px solid #D5D5D5;
}
.job_show .p{
    color:#666;
    font-size:14px;
    line-height: 180%;
    margin-bottom:30px;
}
.job_show .apply{
    background-color: #D6000F;
    display: inline-block;
    width:120px;
    height:40px;
    line-height: 40px;
    color:#fff;
    text-decoration: none;
    border-radius: 3px;
    text-align: center;
    margin:0px auto;
}
.job_show .apply1{
    position: absolute;
    top:80px;
    right:20px;
    background-color: #D6000F;
    display: inline-block;
    width:120px;
    height:40px;
    line-height: 40px;
    color:#fff;
    text-decoration: none;
    border-radius: 3px;
    text-align: center;
    margin:0px auto;
}
.job_show .apply_disable{
    cursor: default;
    background-color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/pages/JobView.vue